module.exports = __webpack_public_path__ + "img/ic-hide.d0539564.svg";